import { Button, CircularProgress, Tooltip } from "@material-ui/core";
import React, { memo } from "react";
import { NewItemDetailsTable } from "./newItemDetailsTable";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import { DocFlowItem } from "src/app/docFlows/domains/prpo/poItem";
import { GRItem } from "src/app/docFlows/domains/prpo/gr.item";
import { AccountDetailsTable } from "./accountDetailsTable";
import DocumentFlow from "src/app/docFlows/domains/documentFlow/documentFlow";
import { newEditRequestPageStyles } from "./newEditRequestPageStyles";
import { EditRequestDeletePopUp } from "./editRequestDeletePopUp";
import {
  getCondtions,
  isItDeLslCXMLVendor,
  isItGbCandexIFrameVendor,
  isItIeCandexIFrameVendor
} from "../../helper";
import { useStylesForToolTip } from "src/app/shared/components/tooltip/toolTip.styles";
import { Formatter } from "src/app/shared/components/amount-formatter";
import { AddMaterialFromPsl } from "./addMaterialFromPsl";
import { useFetchCurrencyDecimals } from "src/app/shared/domains/master/master.hooks";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { FeaturesContext } from "src/app/shared/domains/core/pataflag.context";
import { Features } from "src/app/shared/domains/core/pataflag";
import NewAccountDetailsComponent from "./NewAccountDetails.component";
import { AccTabItem } from "src/app/docFlows/components/dataTable/ItemDetails/accTabItems";
import { AddPricingCondtions } from "./addPricingCondtions";
import { PricingConditions } from "src/app/docFlows/domains/documentFlow/pricingConditions";
import {
  FullWidthLoadingComponent,
  LoadingComponent
} from "src/app/shared/components/loading";
import _ from "lodash";
import { AddMaterialFromCandex_IFrame } from "./AddMaterialFromCandex_IFrame";
import { RootStateStore } from "src/app/application.reducers";
import { useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import { AddMaterialFromLsl_CXML } from "./AddMaterialFromLsl_CXML";
import {
  useFetchPunchoutCatDetails,
  useGetLslUrlData,
  useGetcXMLUrl
} from "src/app/docFlows/hooks/docflow.hooks";
import { environment } from "src/app/shared/domains/core/environment";
import { NbsNotification } from "src/app/nbsCockpit/components/nbsNotification.component";
import { NotificationType } from "src/app/shared/components/notification";
import { LoadingMessage } from "react-select/src/components/Menu";

type editItemDetailsprops = {
  documentFlow: DocumentFlow;
  itemLines: DocFlowItem[];
  totalValDynamic: any;
  dispatchMethod: any;
  showCBbasedOnSupplierStatus: any;
  accountDetailsData: Record<string, AccTabItem[]> | null;
  accountDetailsLineNumbers: string[];
  accDetailsEditedLines: string[];
  accDetailsLoading: boolean;
  grItems?: GRItem[];
  setFinalResendPoData: Function;
  finalResendPodata: any;
  disableDetails?: boolean;
  pricingCondionsData: PricingConditions[];
  vertexData?: any;
  showMtvSection?: boolean;
  mtvConfirmed?: boolean;
  setMtvConfirmed?: React.Dispatch<React.SetStateAction<boolean>>;
  hasOpenedMtvReport?: boolean;
  setHasOpenedMtvReport?: React.Dispatch<React.SetStateAction<boolean>>;
  setShowMtvClickWarning?: React.Dispatch<React.SetStateAction<boolean>>;
  };

const ItemDetails = (props: editItemDetailsprops) => {
  const {
    documentFlow,
    itemLines,
    totalValDynamic,
    dispatchMethod,
    showCBbasedOnSupplierStatus,
    accountDetailsData,
    accountDetailsLineNumbers,
    accDetailsEditedLines,
    accDetailsLoading,
    grItems,
    pricingCondionsData,
    disableDetails = false,
    vertexData = { loading: false, data: {} }
  } = props;
  const firstLineItem = itemLines[0];
  const [selectedData, setSelectedData] = React.useState<DocFlowItem[]>([]);
  const styles = newEditRequestPageStyles({});
  const [open, setOpen] = React.useState(false);
  const [openMaterialPopUp, setOpenMaterialPopUp] = React.useState(false);

  const [openCandexPopUp_IFrame, setOpenCandexPopUp_IFrame] = React.useState(
    false
  );
  const [openLslPopUp_CXML, setOpenLslPopUp_CXML] = React.useState<
    string | null
  >(null);

  const [
    openPricingConditionsPopUp,
    setOpenPricingConditionsPopUp
  ] = React.useState(false);
  const { data: currencyDecimals } = useFetchCurrencyDecimals(
    props.documentFlow.SystemAlias
  );
  const { hasFeature } = React.useContext(FeaturesContext);

  const currentUser = useSelector(
    (state: RootStateStore) => state.shared.user.currentUser
  );
  const selectedPricingConditonsData = pricingCondionsData?.filter(
    item => item?.itemNumber === selectedData[0]?.PrItem
  );

  const totalvalue = (
    <Formatter
      amount={totalValDynamic}
      currency={firstLineItem?.PrCurrency ? firstLineItem?.PrCurrency : ""}
    />
  );
  const classes = useStylesForToolTip({});

  const processId =
    (
      documentFlow?.POCompanyCode?.trim() || documentFlow?.PRCompanyCode?.trim()
    )?.substring(2, 4) + documentFlow?.PurchOrg?.trim()?.substring(2, 4);
  const payloadId = `${new Date()?.getTime()}.${processId}.${uuidv4()}`;

  const [errorMessage, setErrorMessage] = React.useState<string | null>(null);
  const {
    mutateAsync: getCXMLUrl,
    isLoading: fetchingUrl
  } = useGetLslUrlData();
  const {
    mutateAsync: getCXMLUrlV2,
    isLoading: fetchingUrlV2
  } = useGetcXMLUrl();

  const {
    data: punchOutCatalogDetails,
    isLoading: punchOutDetailsLoading
  } = useFetchPunchoutCatDetails(
    documentFlow?.POCompanyCode?.trim() || documentFlow?.PRCompanyCode?.trim(),
    documentFlow?.PurchOrg?.trim(),
    documentFlow.VendorNo?.replace(/^0+/, "")?.trim()
  );

  const isItCandex_IFrame = () => {
    if (hasFeature(Features.RC_174982_PUNCHOUT_AUTOMATED_SOLUTION)) {
      return punchOutCatalogDetails?.protocol === "OCI";
    }
    return (
      (isItGbCandexIFrameVendor(documentFlow) ||
        isItIeCandexIFrameVendor(documentFlow)) &&
      hasFeature(Features.RC_ADD_FROM_CANDEX)
    );
  };

  const isItDeLsl_CXML = () => {
    if (hasFeature(Features.RC_174982_PUNCHOUT_AUTOMATED_SOLUTION)) {
      if (hasFeature(Features.RC_178782_ENABLE_EDIT_PSLPR_WITH_PUNCHOUT_VENDOR)) {
        return punchOutCatalogDetails?.protocol === "cXML" && firstLineItem?.Psl_ID === ""
      }else{
        return punchOutCatalogDetails?.protocol === "cXML"
      }
    }else if(hasFeature(Features.RC_178782_ENABLE_EDIT_PSLPR_WITH_PUNCHOUT_VENDOR)){
      return punchOutCatalogDetails?.protocol === "cXML" && firstLineItem?.Psl_ID === ""
    }
    return (
      isItDeLslCXMLVendor(documentFlow) &&
      hasFeature(Features.ADD_ITEM_FROM_CXML_LSL)
    );
  };

  // hide "Add New Item From PSL" for NestBuy Catalog PRs when toggle is enabled
  const isNestBuyCatalogItem =
    hasFeature(Features.RC_NESTBUY_CATALOG_ITEM_RESTRICTIONS) &&
    (firstLineItem as any)?.PR_From_Item === "NESTBUY CATALOG";

  const handleMassDelete = () => {
    setOpen(true);
  };

  const handleSupCatalogClick = async () => {
    const sessionId = `${uuidv4()}_${
      currentUser.accountName
    }_${new Date().toISOString()}`;

    const xmlToGetUrl = `<?xml version="1.0" encoding="UTF-8"?>
    <!DOCTYPE cXML SYSTEM "http://xml.cxml.org/schemas/cXML/1.2.040/cXML.dtd">
    <cXML payloadID="${payloadId}" timestamp="${new Date().toISOString()}">
        <Header>
            <From>
                <Credential domain=${
                  hasFeature(Features.RC_174982_PUNCHOUT_AUTOMATED_SOLUTION)
                    ? `"${punchOutCatalogDetails?.cxmlFromDomain}"` || `"NetworkID"`
                    : `"NetworkID"`
                }>
                    <Identity>${
                      hasFeature(Features.RC_174982_PUNCHOUT_AUTOMATED_SOLUTION)
                        ? punchOutCatalogDetails?.cxmlFromId
                        : environment.LSL_FROM_CRED
                    }</Identity>
                </Credential>
            </From>
            <To>
                <Credential domain=${
                  hasFeature(Features.RC_174982_PUNCHOUT_AUTOMATED_SOLUTION)
                    ? `"${punchOutCatalogDetails?.cxmlToDomain}"` || `"NetworkID"`
                    : `"NetworkID"`
                }>
                    <Identity>${
                      hasFeature(Features.RC_174982_PUNCHOUT_AUTOMATED_SOLUTION)
                        ? punchOutCatalogDetails?.cxmlToID
                        : environment.LSL_TO_CRED
                    }</Identity>
                </Credential>
            </To>
            <Sender>
                <Credential domain=${
                  hasFeature(Features.RC_174982_PUNCHOUT_AUTOMATED_SOLUTION)
                    ? `"${punchOutCatalogDetails?.senderDomain}"` || `"UserID"`
                    : `"UserID"`
                }>
                    <Identity>${
                      hasFeature(Features.RC_174982_PUNCHOUT_AUTOMATED_SOLUTION)
                        ? punchOutCatalogDetails?.senderId || "buyer"
                        : `"buyer"`
                    }</Identity>
                    <SharedSecret>${
                      hasFeature(Features.RC_174982_PUNCHOUT_AUTOMATED_SOLUTION)
                        ? Buffer.from(
                            punchOutCatalogDetails?.password || " ",
                            "base64"
                          ).toString()
                        : environment.LSL_SHARED_SECRET
                    }</SharedSecret>
                </Credential>
                <UserAgent>S2P Request Cockpit v1</UserAgent>
            </Sender>
        </Header>
        <Request>
            <PunchOutSetupRequest operation="create">
                <BuyerCookie>${sessionId}</BuyerCookie>
                <Extrinsic name="UserEmail">${currentUser.email}</Extrinsic>
                <Extrinsic name="UserFullName">${currentUser.name}</Extrinsic>
                <Extrinsic name="UniqueName">${
                  currentUser.accountName
                }</Extrinsic>
                <BrowserFormPost>
                    <URL>${
                      environment.REACT_APP_API_BASE
                    }/api/Candex/Cxml?sessionId=${sessionId}&amp;prNumber=${
      documentFlow?.PurchaseReqNo
    }</URL>
                </BrowserFormPost>
				                <ShipTo>
<Address  >
  <Name xml:lang="en"> </Name>
<PostalAddress name="default">
  <DeliverTo />
  <Street />
  <Street />
  <City />
  <State />
  <PostalCode />
  <Country isoCountryCode="CH"/>
  </PostalAddress> 
  </Address>
  </ShipTo>
            </PunchOutSetupRequest>
        </Request>
    </cXML>
    `;

    try {
      const url: string = await (hasFeature(
        Features.RC_174982_PUNCHOUT_AUTOMATED_SOLUTION
      )
        ? getCXMLUrlV2({
            xmlData: xmlToGetUrl,
            url: punchOutCatalogDetails?.url
          })
        : getCXMLUrl(xmlToGetUrl));
      window.open(url, "_blank");
      setOpenLslPopUp_CXML(sessionId);
    } catch (error) {
      // setOpenLslPopUp_CXML(sessionId);
      setErrorMessage(error?.toString());
      // window.open("https://portal.lsl.de/staging/nestle/?aribaotp=67e6b225196cf4.81324410", '_blank');
    }
  };

  const isDeletionAllowed: boolean = selectedData.some(item => {
    const fieldLevelConditions = getCondtions(item);
    return fieldLevelConditions.isThereGR || fieldLevelConditions.isThereIR;
  });

const showTotalOrTotalWithTax = () => {
  const data = vertexData.data.data;
  const totalWithTax = _.isEmpty(data)
    ? Number(totalValDynamic)
    : data?.totalTax + Number(totalValDynamic);

  const vertexItemExist = itemLines.filter(
    (item: any) => item.Taxcode === "I1"
  );

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>

      {/* ✅ MTV SECTION — EXACTLY ABOVE TOTAL */}
      {props.showMtvSection && (
        <div style={{ marginBottom: 10 }}>

          <a
            href="https://app.powerbi.com/"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => props.setHasOpenedMtvReport?.(true)}
            style={{
              color: "#F19001",
              fontWeight: 600,
              fontSize: 13,
              textDecoration: "underline",
              display: "block",
              marginBottom: 4
            }}
          >
            Open MTV Annual Spend Report
          </a>

          <label style={{ fontSize: 12 }}>
            <input
              type="checkbox"
              checked={props.mtvConfirmed}
              onChange={(e) => {
                if (!props.hasOpenedMtvReport) {
                  props.setShowMtvClickWarning?.(true);
                  return;
                }
                props.setMtvConfirmed?.(e.target.checked);
              }}
            />
            <span style={{ marginLeft: 6 }}>
              I Verify
            </span>
          </label>
        </div>
      )}

      {/* ✅ TOTAL REQUESTED AMOUNT */}
      <div className={styles.totalHeading}>
        Total Requested Amount:
        <span className={styles.totalValue}>{totalvalue}</span>
      </div>

      {/* ✅ TOTAL WITH TAX */}
      {!_.isEmpty(data) && vertexItemExist.length > 0 && (
        <div className={styles.totalHeading}>
          Total Amount With Tax:
          <span className={styles.totalValue}>
            <Formatter
              amount={totalWithTax.toString()}
              currency={firstLineItem?.PrCurrency || ""}
            />
          </span>
        </div>
      )}
    </div>
  );
};
  return (
    <div style={{ width: "100%", height: "100%" }}>
      {props.itemLines.length > 0 ? (
        <>
          <div
            className={styles.itemHeader}
            style={{ marginBottom: !!selectedData.length ? 10 : 15 }}
          >
            {/* <div className={`${styles.header} ${styles.boldFont}`} style={{ margin: 0 }}>ITEM DETAILS {hasFeature(Features.RC_166302_SHOW_US_TAX_CALCULATIONS) && documentFlow.POCompanyCode.substring(0, 2).toLocaleUpperCase() === 'Z2' && <InfoHoverIcon popUpComponent={<TaxCalculationsPopup taxAmount={"100"} />} />}</div> */}
            <div
              className={`${styles.header} ${styles.boldFont}`}
              style={{ margin: 0 }}
            >
              ITEM DETAILS
            </div>
            {hasFeature(Features.RC_166302_SHOW_US_TAX_CALCULATIONS) ? (
              !vertexData.loading && (
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  {!disableDetails && (
                    <>
                      {hasFeature(Features.RC_168614_PRICING_CONDITIONS) &&
                        getCondtions(firstLineItem)?.isItEasyRequestPR &&
                        selectedData.length === 1 && (
                          <Button
                            className={styles.deleteButton}
                            onClick={() => setOpenPricingConditionsPopUp(true)}
                            style={{
                              paddingLeft: 14,
                              paddingRight: 14,
                              color: "#F19001",
                              cursor: "pointer"
                            }}
                          >
                            <AddCircleOutlineIcon />
                            <div style={{ marginLeft: "5px" }}>
                              {selectedPricingConditonsData?.length > 0
                                ? "Add / Update Condition Type"
                                : `Add Condition Type`}
                            </div>
                          </Button>
                        )}
                      {punchOutDetailsLoading ? (
                        <FullWidthLoadingComponent text={"Checking "} />
                      ) : (
                        <>
                          {isItCandex_IFrame() && (
                            <Button
                              className={styles.deleteButton}
                              onClick={() => setOpenCandexPopUp_IFrame(true)}
                              style={{
                                paddingLeft: 14,
                                paddingRight: 14,
                                color: "#F19001",
                                cursor: "pointer"
                              }}
                            >
                              <AddCircleOutlineIcon />
                              <div style={{ marginLeft: "5px" }}>
                                Add New Item From Candex
                              </div>
                            </Button>
                          )}
                          {isItDeLsl_CXML() && (
                            <Button
                              className={styles.deleteButton}
                              onClick={handleSupCatalogClick}
                              style={{
                                paddingLeft: 14,
                                paddingRight: 14,
                                color: "#F19001",
                                cursor: "pointer"
                              }}
                            >
                              {fetchingUrl || fetchingUrlV2 ? (
                                <CircularProgress className={styles.sending} />
                              ) : (
                                <AddCircleOutlineIcon />
                              )}
                              <div style={{ marginLeft: "5px" }}>
                                Access Supplier Catalog
                              </div>
                            </Button>
                          )}
                          {!(isItCandex_IFrame() || isItDeLsl_CXML() || isNestBuyCatalogItem) && (
                            <Button
                              className={styles.deleteButton}
                              onClick={() => setOpenMaterialPopUp(true)}
                              style={{
                                paddingLeft: 14,
                                paddingRight: 14,
                                color: "#F19001",
                                cursor: "pointer"
                              }}
                            >
                              <AddCircleOutlineIcon />
                              <div style={{ marginLeft: "5px" }}>
                                Add New Item From PSL
                              </div>
                            </Button>

                          )}
                          {/* {props.showMtvSection && (
                            <div style={{ display: "flex", flexDirection: "column", marginLeft: 10 }}>
                              <a
                                href="https://app.powerbi.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={() => props.setHasOpenedMtvReport?.(true)}
                                style={{
                                  color: "#F19001",
                                  fontWeight: 600,
                                  fontSize: 13
                                }}
                              >
                                Open MTV Annual Spend Report
                              </a>

                              <label style={{ fontSize: 12 }}>
                                <input
                                  type="checkbox"
                                  checked={props.mtvConfirmed}
                                  onChange={(e) => {
                                    if (!props.hasOpenedMtvReport) {
                                      props.setShowMtvClickWarning?.(true);
                                      return;
                                    }
                                    props.setMtvConfirmed?.(e.target.checked);
                                  }}
                                />
                                <span style={{ marginLeft: 6 }}>
                                  I confirm that I have verified the total utilized amount
                                </span>
                              </label>
                            </div>
                          )} */}
                        </>
                      )}
                      {selectedData.length != 0 && (
                        <Tooltip
                          interactive
                          classes={{ tooltip: classes.customTooltip }}
                          title={
                            isDeletionAllowed
                              ? "Document with history (GR or IR) cannot be deleted"
                              : ""
                          }
                          placement="bottom-start"
                        >
                          <Button
                            className={styles.deleteButton}
                            onClick={!isDeletionAllowed && handleMassDelete}
                            style={{
                              paddingLeft: 14,
                              paddingRight: 14,
                              color: !isDeletionAllowed
                                ? "#F19001"
                                : "lightgrey",
                              cursor: !isDeletionAllowed
                                ? "pointer"
                                : "not-allowed"
                            }}
                          >
                            <DeleteForeverIcon />
                            <div style={{ marginLeft: "5px" }}>Mass Delete</div>
                          </Button>
                        </Tooltip>
                      )}
                    </>
                  )}

                  {hasFeature(Features.RC_166302_SHOW_US_TAX_CALCULATIONS) ? (
                    showTotalOrTotalWithTax()
                  ) : (
                    <div className={styles.totalHeading}>
                      Total Requested Amount:
                      <span className={styles.totalValue}>{totalvalue}</span>
                    </div>
                  )}
                </div>
              )
            ) : (
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                {!disableDetails && (
                  <>
                    {hasFeature(Features.RC_168614_PRICING_CONDITIONS) &&
                      getCondtions(firstLineItem)?.isItEasyRequestPR &&
                      selectedData.length === 1 && (
                        <Button
                          className={styles.deleteButton}
                          onClick={() => setOpenPricingConditionsPopUp(true)}
                          style={{
                            paddingLeft: 14,
                            paddingRight: 14,
                            color: "#F19001",
                            cursor: "pointer"
                          }}
                        >
                          <AddCircleOutlineIcon />
                          <div style={{ marginLeft: "5px" }}>
                            {selectedPricingConditonsData?.length > 0
                              ? "Add / Update Condition Type"
                              : `Add Condition Type`}
                          </div>
                        </Button>
                      )}
                    {isItCandex_IFrame() && (
                      <Button
                        className={styles.deleteButton}
                        onClick={() => setOpenCandexPopUp_IFrame(true)}
                        style={{
                          paddingLeft: 14,
                          paddingRight: 14,
                          color: "#F19001",
                          cursor: "pointer"
                        }}
                      >
                        <AddCircleOutlineIcon />
                        <div style={{ marginLeft: "5px" }}>
                          Add New Item From Candex
                        </div>
                      </Button>
                    )}
                    {isItDeLsl_CXML() && (
                      <Button
                        className={styles.deleteButton}
                        onClick={handleSupCatalogClick}
                        style={{
                          paddingLeft: 14,
                          paddingRight: 14,
                          color: "#F19001",
                          cursor: "pointer"
                        }}
                      >
                        <AddCircleOutlineIcon />
                        <div style={{ marginLeft: "5px" }}>
                          Access Supplier Catalog
                        </div>
                      </Button>
                    )}
                    {!(isItCandex_IFrame() || isItDeLsl_CXML() || isNestBuyCatalogItem) && (
                      <Button
                        className={styles.deleteButton}
                        onClick={() => setOpenMaterialPopUp(true)}
                        style={{
                          paddingLeft: 14,
                          paddingRight: 14,
                          color: "#F19001",
                          cursor: "pointer"
                        }}
                      >
                        <AddCircleOutlineIcon />
                        <div style={{ marginLeft: "5px" }}>
                          Add New Item From PSL
                        </div>
                      </Button>
                    )}
                    {/* {
                                                // firstLineItem?.Psl_ID !== "" && (firstLineItem?.Psl_ID?.startsWith('C') || firstLineItem?.Psl_ID?.startsWith('L')) && hasFeature(Features.RC_163946_ADD_NEW_ITEM_BUTTON)  &&
                                                <Button
                                                    className={styles.deleteButton}
                                                    onClick={() => setOpenMaterialPopUp(true)}
                                                    style={{
                                                        paddingLeft: 14, paddingRight: 14,
                                                        color: "#F19001",
                                                        cursor: "pointer"
                                                    }}>
                                                    <AddCircleOutlineIcon />
                                                    <div style={{ marginLeft: "5px" }} >Add New Item From PSL</div>
                                                </Button>
                                            } */}
                    {selectedData.length != 0 && (
                      <Tooltip
                        interactive
                        classes={{ tooltip: classes.customTooltip }}
                        title={
                          isDeletionAllowed
                            ? "Document with history (GR or IR) cannot be deleted"
                            : ""
                        }
                        placement="bottom-start"
                      >
                        <Button
                          className={styles.deleteButton}
                          onClick={!isDeletionAllowed && handleMassDelete}
                          style={{
                            paddingLeft: 14,
                            paddingRight: 14,
                            color: !isDeletionAllowed ? "#F19001" : "lightgrey",
                            cursor: !isDeletionAllowed
                              ? "pointer"
                              : "not-allowed"
                          }}
                        >
                          <DeleteForeverIcon />
                          <div style={{ marginLeft: "5px" }}>Mass Delete</div>
                        </Button>
                      </Tooltip>
                    )}
                  </>
                )}

                {hasFeature(Features.RC_166302_SHOW_US_TAX_CALCULATIONS) ? (
                  showTotalOrTotalWithTax()
                ) : (
                  <div className={styles.totalHeading}>
                    Total Requested Amount:
                    <span className={styles.totalValue}>{totalvalue}</span>
                  </div>
                )}
              </div>
            )}
          </div>
          {hasFeature(Features.RC_166302_SHOW_US_TAX_CALCULATIONS) ? (
            vertexData.loading ? (
              <LoadingComponent />
            ) : (
              <NewItemDetailsTable
                disbaleItemDetails={disableDetails}
                currencyDecimals={currencyDecimals}
                lineItems={itemLines}
                documentFlow={documentFlow}
                setSelectedData={setSelectedData}
                dispatchMethod={dispatchMethod}
                showCBbasedOnSupplierStatus={showCBbasedOnSupplierStatus}
                setFinalResendPoData={props.setFinalResendPoData}
                finalResendPodata={props.finalResendPodata}
                punchOutCatalogDetails={punchOutCatalogDetails}
                vertexData={vertexData}
              />
            )
          ) : (
            <NewItemDetailsTable
              disbaleItemDetails={disableDetails}
              currencyDecimals={currencyDecimals}
              lineItems={itemLines}
              documentFlow={documentFlow}
              setSelectedData={setSelectedData}
              dispatchMethod={dispatchMethod}
              showCBbasedOnSupplierStatus={showCBbasedOnSupplierStatus}
              setFinalResendPoData={props.setFinalResendPoData}
              finalResendPodata={props.finalResendPodata}
              punchOutCatalogDetails={punchOutCatalogDetails}
            />
          )}
        </>
      ) : (
        <div>Line items have been deleted</div>
      )}
      <div className={`${styles.header} ${styles.boldFont}`}>
        ACCOUNT DETAILS
      </div>
      {props.itemLines.length > 0 ? (
        hasFeature(Features.RC_163868_NEW_ACCOUNT_TAB) ? (
          <NewAccountDetailsComponent
            disableAccountDetails={disableDetails}
            documentFlow={documentFlow}
            lineItems={itemLines}
            dispatchMethod={dispatchMethod}
            accountDetailsData={accountDetailsData}
            accountDetailsLineNumbers={accountDetailsLineNumbers}
            accDetailsEditedLines={accDetailsEditedLines}
            accDetailsLoading={accDetailsLoading}
            grItems={grItems}
          />
        ) : (
          <AccountDetailsTable
            lineItems={itemLines}
            documentFlow={documentFlow}
            dispatchMethod={dispatchMethod}
            grItems={grItems}
          ></AccountDetailsTable>
        )
      ) : (
        <div>Line items have been deleted</div>
      )}
      {open && (
        <EditRequestDeletePopUp
          open={open}
          setOpen={setOpen}
          toBeDeleteditems={selectedData}
          dispatchMethod={dispatchMethod}
        ></EditRequestDeletePopUp>
      )}
      {openCandexPopUp_IFrame && (
        <AddMaterialFromCandex_IFrame
          currencyDecimals={currencyDecimals}
          punchOutCatalogDetails = {punchOutCatalogDetails}
          lineItems={itemLines}
          documentFlow={documentFlow}
          setOpenCandexPopUp_IFrame={setOpenCandexPopUp_IFrame}
          dispatchMethod={dispatchMethod}
          sessionId={`${uuidv4()}_${
            currentUser.accountName
          }_${new Date().toISOString()}`}
        />
      )}
      {openLslPopUp_CXML && (
        <AddMaterialFromLsl_CXML
          currencyDecimals={currencyDecimals}
          lineItems={itemLines}
          documentFlow={documentFlow}
          setOpenLslPopUp_CXML={setOpenLslPopUp_CXML}
          dispatchMethod={dispatchMethod}
          sessionId={openLslPopUp_CXML}
        />
      )}
      {openMaterialPopUp && (
        <AddMaterialFromPsl
          currencyDecimals={currencyDecimals}
          lineItems={itemLines}
          documentFlow={documentFlow}
          setOpenChatSearch={setOpenMaterialPopUp}
          openChatSearch={openMaterialPopUp}
          dispatchMethod={dispatchMethod}
        />
      )}
      {openPricingConditionsPopUp && (
        <AddPricingCondtions
          selectedPricingConditonsData={selectedPricingConditonsData || []}
          selectedItem={selectedData[0]}
          documentFlow={documentFlow}
          setOpenPricingConditionsPopUp={setOpenPricingConditionsPopUp}
          dispatchMethod={dispatchMethod}
        />
      )}
      {errorMessage && (
        <NbsNotification
          type={NotificationType.error}
          message={errorMessage}
          open={!!errorMessage}
          setOpen={setErrorMessage}
        />
      )}
    </div>
  );
};

export default memo(ItemDetails);


 